
const ROOT_URL = window.location.protocol + "//" + window.location.host
console.log(' THIS IS ROOT_URL:', ROOT_URL)
export const API_URL_BASE=ROOT_URL.includes('localhost')?'http://192.168.0.39:9000':ROOT_URL